import React, { useEffect, useState } from "react";
import Header from "../../../../Componets/Header";
import Table from "../../../../Componets/Table";
import { toast } from "react-toastify";
import headers from "../../../../Data/Tables/Settings/Settings/headers";
import Menus from "../../../../Componets/Menus";
import UsersIcon from "../../../../Assets/Svg/users";
import BranchIcon from "../../../../Assets/Svg/branch";
import SettingIcon from "../../../../Assets/Svg/settings";
import TaxIcon from "../../../../Assets/Svg/tax";
import ProductIcon from "../../../../Assets/Svg/products";
import ExpenseIcon from "../../../../Assets/Svg/expense";
import {
  DownloadOutlined,
  UploadOutlined,
  WindowsFilled,
  WindowsOutlined,
  ApartmentOutlined 
} from "@ant-design/icons";
import UploadIcon from "../../../../Assets/Svg/upload";
import BillingIcon from "../../../../Assets/Svg/billing";
import { get_user_auth } from "../../../../Controllers/Layouts/Layouts";
import Loadercomponent from "../../../../Componets/Loader";

const SettingsTable = () => {
  let header = headers;

  const [body, setBody] = useState();
  const [loader, setLoader] = useState(false);
  const [authorizeMail, setAuthorizeMail] = useState(false);

  const fetchData = async () => {
    try {
      setLoader(true);
      const response = await get_user_auth();
      if (response?.status) {
        const authorize_email =
          response?.data?.email?.trim().toLowerCase() ===
          process.env.REACT_APP_AUTHORIZE_EMAIL?.trim().toLowerCase();

        setAuthorizeMail(authorize_email);
        setLoader(false);
      } else {
        toast?.error(response?.message || "Failed to fetch User Auth");
      }
    } catch (errors) {
      setLoader(false);
      toast?.error(errors?.message);
    }
  };


  const formdata = async (data) => {
    console.log(data);
  };

  useEffect(() => {
    fetchData();
  }, []);

  const menu = [
    {
      icon: <SettingIcon />,
      name: "General",
      description: "View and update your details",
      url: "/app/settings/general",
    },
    {
      icon: <BranchIcon />,
      name: "Branches",
      description: "View  create & update branch details",
      url: "/app/settings/branches",
    },
    {
      icon: <UsersIcon />,
      name: "Users",
      description: "View  create & update user details",
      url: "/app/settings/users",
    },
    {
      icon: <UsersIcon />,
      name: "User roles",
      description: "View , create & update user role",
      url: "/app/settings/roles",
    },
    {
      icon: <TaxIcon />,
      name: "Tax",
      description: "View , create & update tax",
      url: "/app/settings/tax",
    },
    // {
    //   icon: <UploadIcon />,
    //   name: "Import",
    //   description: "Upload , master products to branches",
    //   url: "/app/settings/import",
    // },
    {
      icon: <SettingIcon />,
      name: "Upgrade the Plan",
      description: "View Current Plan and Compare with Other Existing Plans",
      url: "/app/settings/upgrade-plans",
    },
    ...(authorizeMail
      ? [
        {
          icon: <ApartmentOutlined  />,
          name: "OptiksPro Entire Branches List",
          description:
            "View all branches, sub-branches, renewed year, and expiry date",
          url: "/app/settings/Admin",
        },
      ]
      : []),
  ];

  return (
    <Header header={header} formdata={formdata}>
      {/* <a
        className="text-medium text-green-600 float-end text-lg"
        href="/managepharmacys/production/Managepharmacys Setup 1.0.0.exe"
        download
      >
        <WindowsFilled />
        <span className="pl-2">Download</span>
      </a> */}
      <Loadercomponent loader={loader}>
        <div className="mt-4 grid grid-cols-4 gap-4">
          {menu?.map((value, index) => {
            return (
              <Menus
                className="flex bg-white p-4 rounded-lg border cursor-pointer setting-card hover:bg-gray-100"
                icon={value?.icon}
                name={value?.name}
                description={value?.description}
                url={value?.url}
              />
            );
          })}
        </div>
      </Loadercomponent>
    </Header>
  );
};

export default SettingsTable;
